import Vue from 'vue';
import moment from "moment";

export const backendAddress = function (url) {
  if (url == null) url = "";

  return process.env.VUE_APP_BACKEND_URL + url;
};

export const roles = {
  agent: 'agent',
  manager: 'manager',
  super_admin: 'super_admin'
};

export const isInRole = function (role) {
  return +this.$store.getters.userRole === role;
};

export const getTokenData = () => {
  if (sessionStorage.getItem("token")) {
    let jwtData = sessionStorage.getItem("token").split(".")[1];
    let decodedJwtJsonData = decodeURIComponent(
      Array.prototype.map
      .call(atob(jwtData), function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
    );
    var decodedJwtData = JSON.parse(decodedJwtJsonData);
    return decodedJwtData;
  }
  return {
    isInAdminRole: false,
    userId: "",
    userRole: "",
    userName: ""
  };
};

export const displayInfo = function (content) {
  Vue.notify({
    classes: "",
    group: "notify-group",
    title: "",
    duration: 8000,
    type: 'bg-success text-white rounded',
    text: content
  });
};

export const validationError = function (error) {
  Vue.notify({
    classes: "",
    group: "notify-group",
    title: "",
    type: "bg-danger text-white rounded",
    duration: 5000,
    text: error
  });
};

export const displayErrors = function (error) {
  Vue.notify({
    classes: "",
    group: "notify-group",
    title: "",
    type: "bg-danger text-white rounded",
    duration: 8000,
    text: error
  });
};

export const fromIntToTime = value => {
  return moment.utc(value * 1000).format('HH:mm:ss')
}

export const subtractSecondsDateTime = (dateTime, seconds) => {

  return moment(dateTime).subtract(+seconds, 'seconds').format("YYYY-MM-DD HH:mm:ss")
}

export const dateTime_hhmmss = value => {
  if (value) {
    return moment(value).format("YYYY-MM-DD HH:mm:ss");
  }
};

export const dateTime = value => {
  if (value) {
    return moment(value).format("YYYY-MM-DD HH:mm");
  }
};

export const hourTime = value => {
  if (value) {
    return moment(value).format("HH:mm");
  }
};

export const dateFormat = value => {
  if (value) {
    return moment(value).format("YYYY-MM-DD");
  }
};

export const currencyFormat = value => {
  if (value === null || value == 0) return 0;

  if (value) {
    return value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1 ");
  }
};

export const getDictionaryObject = function (enumList, key) {
  var list = [];

  if (key === null) return defaultDictionaryObject();

  if (enumList && enumList.length)
    list = enumList.filter(item => item.key === key);

  return list.length === 1 ? list[0] : defaultDictionaryObject();
};

export const getDictionaryLabel = function (enumList, value) {
  var list = [];

  if (value === null) return defaultDictionaryObject().label;

  if (enumList && enumList.length)
    list = enumList.filter(item => item.value === value);

  return list.length === 1 ? list[0].label : defaultDictionaryObject().label;
};

const defaultDictionaryObject = function () {
  return {
    value: "",
    color: "red",
    icon: "fa fa-exclamation",
    key: 0,
    label: ""
  }
}

export const mpsToKph = function (value) {
  return (parseFloat(value) * 3.6).toFixed(2); //meter per second to km per h
};
